import AuerInvoiceHistoryState from "@auer-steel/Store/Pages/InvoiceHistory/AuerInvoiceHistoryState";
import { createTypedReducerWithImmer } from "@insite/client-framework/Common/CreateTypedReducer";
import { Draft } from "immer";

const initialState: AuerInvoiceHistoryState = {
    selectedInvoices: [],
    allInvoicesSelected:false
};

const reducer = {
    "Pages/AuerInvoiceHistory/UpdateSelectedInvoices": (
        draft: Draft<AuerInvoiceHistoryState>,
        action: { parameter: string[] },
    ) => {
        draft.selectedInvoices = action.parameter;
    },
    "Pages/AuerInvoiceHistory/UpdateAllInvoicesSelected" : (
        draft:Draft<AuerInvoiceHistoryState>, 
        action: { parameter: boolean }
        ) => {
        draft.allInvoicesSelected = action.parameter;
    }
};

export default createTypedReducerWithImmer(initialState, reducer);
